// src/components/Analytics.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      // Manually trigger a page_view every time the URL changes
      window.gtag('config', 'G-9NF3RXXN7G', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // This component doesn't render anything UI-wise
};

export default Analytics;